module.exports = __webpack_public_path__ + "img/임휘재 큐레이터.57553001.jpg";